<template>
  <pt-active-sign-detail class="pt-active-sign-detail__withData" :id="id"></pt-active-sign-detail>
</template>

<script>
import PtActiveSignDetail from './index'
export default {
  name: 'pt-active-sign-detail__withData',
  components: {
    'pt-active-sign-detail': PtActiveSignDetail
  },
  props: {
    id: {
      type: String
    }
  }
}
</script>
